import React from "react";
import { getTransformedId } from "@qlik/qlik/src/lib/util/format";
import Cta from "@qlik/qlik/src/components/Cta";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import SingleIconCardWithShadow from "../../Card/Single-Icon-Card-With-Shadow";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";

/**
 * CardModuleWithShadow component
 * @param {Object} data - The data for the CardModuleWithShadow
 * @returns {JSX.Element} - The CardModuleWithShadow component
 */
const CardModuleWithShadow = ({ data }) => {
    // Destructuring the data object to get the required properties
    const { title, subtitle, description, cardItems = [], additionalConfiguration, cta = [], customId } = data ?? {};
    // Check if the cardItems length is less than or equal to 4
    const customGrid = cardItems?.length <= 3;
    // Check if the first row should be rendered based on the data properties
    const shouldRenderFirstRow = title || subtitle || description?.description;

    // Get the class name for the section padding
    const sectionPaddingClassName = getSpacingClassName(additionalConfiguration);
    const { sectionColorMapping } = getColorClassName(data?.backgroundColor);
    return (
        <section
            data-section
            id={customId ?? data.id}
            className={`py-12.5 lg:pt-30 lg:pb-20 scroll-mt-45 ${styles.mobileTitle} ${sectionPaddingClassName} ${sectionColorMapping.bgColor}`}
        >
            <div className="container">
                {shouldRenderFirstRow && (
                    <div className="row">
                        <div className="col-12 mb-5 md:mb-14.5">
                            {title && (
                                <h2
                                    className={`text-center mb-5 ${sectionColorMapping.primaryTextColor}`}
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                                />
                            )}
                            {subtitle && (
                                <p className={`body-big text-center mb-5 ${sectionColorMapping.secondaryTextColor}`}>
                                    {subtitle}
                                </p>
                            )}
                            {description?.description && (
                                <p className={`body-big text-center mb-5 ${sectionColorMapping.secondaryTextColor}`}>
                                    {description?.description}
                                </p>
                            )}
                        </div>
                    </div>
                )}
                <div className={`${customGrid ? "md:flex md:flex-row md:gap-7.5" : "row"}`}>
                    {cardItems?.map((cardItem) => (
                        <div
                            className={`mb-5 ${customGrid ? " flex-1" : "col-12 md:col-6 lg:col-3"}`}
                            key={cardItem.id}
                        >
                            <SingleIconCardWithShadow data={cardItem} />
                        </div>
                    ))}
                </div>
                {cta && cta?.length > 0 && (
                    <div className="row pt-7.5 md:pt-15">
                        <div className="col-12 mb-2.5">
                            {cta?.map((link, index) => (
                                <Cta
                                    key={link.id}
                                    data={link}
                                    className={`block mb-7.5 mx-auto ${index === 0 ? "" : "md:text-md text-center"}`}
                                />
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default CardModuleWithShadow;
